import React from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faLoader,
} from "@awesome.me/kit-c1b85ff10f/icons/classic/light";
import { dictionary } from "../../utilities/dictionary";
import { useAppContext } from "../../AppProvider";
import { ButtonUtility } from "../../Components/common/Buttons/ButtonUtility";
import { ButtonConfirm } from "../../Components/common/Buttons/ButtonConfirm";
import { usePrintShipmentContext } from "./providers/Print";

export const Print = () => {
  const { dictionary } = useAppContext();

  const context = usePrintShipmentContext();
  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col">
          <label className="label-4 text-center">
            {dictionary.actions.confirm_download}
          </label>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col">
          <label className="label-5 text-center">
            {context.shipments?.length > 1
              ? dictionary.messages.ask_download_shipment_labels
              : dictionary.messages.ask_download_shipment_label}
          </label>
        </div>
      </div>
      <div className="d-flex">
        <ButtonUtility
          className="w-50 me-2"
          onClick={() => {
            if (context.callback) {
              context.callback();
            }
          }}
        >
          {dictionary.actions.cancel}
        </ButtonUtility>
        <ButtonConfirm
          className="w-50"
          onClick={() => context.printShipments()}
          disabled={context.shipmentsLoader}
        />
      </div>
    </React.Fragment>
  );
};
